import { useFormikContext } from 'formik';
import { LiquidityV3TokenDenominator, LiquidityV3TriggerFormValues } from 'src/modules/triggers/domain';

import { Callout } from '@/components/callouts/Callout';
import { FormikSelect } from '@/components/forms';
import { Collapsible, CollapsibleContent, Grid, GridItem, SelectItem } from '@/design-system/components/ui';

export const PositionValuesActive = () => {
  const { values } = useFormikContext<LiquidityV3TriggerFormValues>();
  const poolDetails = values._poolDetails;

  const hasSelectedCurrency = !!values.tokenDenominator;
  const selectedCurrencySymbol =
    values.tokenDenominator === LiquidityV3TokenDenominator.Token0
      ? poolDetails?.token0.symbol
      : poolDetails?.token1.symbol;
  const opositeCurrencySymbol =
    selectedCurrencySymbol === poolDetails?.token0.symbol ? poolDetails?.token1.symbol : poolDetails?.token0.symbol;

  const isDisabled = !poolDetails;

  return (
    <Grid cols={12} gap={4} className="tw:col-span-12">
      <GridItem span={12}>
        <FormikSelect name="tokenDenominator" label="Position denominator" disabled={isDisabled}>
          <SelectItem key={poolDetails?.token0.symbol} value={LiquidityV3TokenDenominator.Token0}>
            {poolDetails?.token0.symbol}
          </SelectItem>
          <SelectItem key={poolDetails?.token1.symbol} value={LiquidityV3TokenDenominator.Token1}>
            {poolDetails?.token1.symbol}
          </SelectItem>
        </FormikSelect>
      </GridItem>

      <GridItem span={12}>
        <Collapsible open={!!hasSelectedCurrency}>
          <CollapsibleContent>
            <Callout
              title={`Positions will be tracked in ${selectedCurrencySymbol}`}
              body={`${opositeCurrencySymbol} holdings will be converted into ${selectedCurrencySymbol} to calculate the final position value.`}
              type="info"
            />
          </CollapsibleContent>
        </Collapsible>
      </GridItem>
    </Grid>
  );
};
